import type { LucideIcon } from 'lucide-react'
import type { BusinessIcon } from '@/constants/content'

import {
    BriefcaseBusiness,
    Building2,
    PackageOpen,
    Presentation,
    Store,
    Tent,
    UtensilsCrossed
} from 'lucide-react'

// One icon per business category, shared by the Businesses section and the "What is Bucky AI?" overview.
export const businessIcons: Record<BusinessIcon, LucideIcon> = {
    store: Store,
    utensils: UtensilsCrossed,
    building: Building2,
    presentation: Presentation,
    tent: Tent,
    package: PackageOpen,
    briefcase: BriefcaseBusiness
}
